(function () {
  'use strict';

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
    var locale = document.documentElement.lang || 'pt-BR';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function initSamplesSection(root) {
    if (root.dataset.samplesInit === 'true') return;

    var wrapper = root.querySelector('.section-samples__wrapper');
    var dataElement = root.querySelector('[data-samples-data]');
    var addButton = root.querySelector('.ordered-footer__add-button');
    var totalPriceElement = root.querySelector('.total-wrapper__price');
    var quantityElement = root.querySelector('.ordered-heading__quantity');
    var chosenList = root.querySelector('.images-list__chosen');

    if (!wrapper || !dataElement || !addButton || !totalPriceElement || !quantityElement || !chosenList) return;

    root.dataset.samplesInit = 'true';

    var samples = [];
    try {
      samples = JSON.parse(dataElement.textContent) || [];
    } catch (error) {
      samples = [];
    }

    var chosen = {};

    var swiperElement = root.querySelector('.section-samples__swiper');
    if (swiperElement && window.Swiper) {
      new Swiper(swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        scrollbar: {
          el: root.querySelector('.section-samples__swiper-scrollbar'),
          draggable: true
        }
      });
    }

    function selectedCount() {
      return Object.keys(chosen).length;
    }

    function updateAddButtonState() {
      var quantity = selectedCount();

      addButton.disabled = quantity === 0;
      quantityElement.textContent = quantity + ' ' + (quantityElement.dataset.selected || '');

      root.querySelectorAll('.images-list__empty, .images-list__empty-image').forEach(function (element) {
        element.style.display = quantity > 0 ? 'none' : 'block';
      });
    }

    function updateTotalPrice() {
      var total = 0;
      for (var id in chosen) total += chosen[id].price;
      totalPriceElement.textContent = formatMoney(total);
    }

    function toggleSample(card) {
      var id = card.getAttribute('data-id');
      var sample = null;
      for (var i = 0; i < samples.length; i++) {
        if (String(samples[i].id) === id) {
          sample = samples[i];
          break;
        }
      }
      if (!sample) return;

      if (card.classList.contains('added')) {
        card.classList.remove('added');
        delete chosen[id];
        chosenList.querySelectorAll('img[data-id="' + id + '"]').forEach(function (image) {
          image.remove();
        });
      } else {
        card.classList.add('added');
        chosen[id] = { price: sample.price };

        var thumbnailSrc = card.dataset.thumbnail;
        if (!thumbnailSrc) {
          var image = card.querySelector('.sample__image-wrapper img');
          thumbnailSrc = image ? image.currentSrc || image.src : '';
        }
        if (thumbnailSrc) {
          var thumbnail = document.createElement('img');
          thumbnail.src = thumbnailSrc;
          thumbnail.alt = '';
          thumbnail.className = 'chosen_img';
          thumbnail.setAttribute('data-id', id);
          chosenList.appendChild(thumbnail);
        }
      }

      updateTotalPrice();
      updateAddButtonState();
    }

    function resetSelection() {
      chosen = {};
      chosenList.querySelectorAll('img').forEach(function (image) {
        image.remove();
      });
      wrapper.querySelectorAll('.sample__wrapper.added').forEach(function (card) {
        card.classList.remove('added');
      });
      updateTotalPrice();
      updateAddButtonState();
    }

    wrapper.addEventListener('click', function (event) {
      var card = event.target.closest('.sample__wrapper');
      if (card) toggleSample(card);
    });

    addButton.addEventListener('click', function () {
      var items = Object.keys(chosen).map(function (id) {
        return { id: parseInt(id, 10), quantity: 1 };
      });
      if (items.length === 0) return;

      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');

      var bundledSections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: bundledSections }
        })
      );

      var payload = { items: items };
      if (bundledSections.length > 0) payload.sections = bundledSections.join(',');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (body) {
              throw new Error((body && body.description) || 'cart/add.js respondeu ' + response.status);
            });
          }
          return response.json();
        })
        .then(function (responseJson) {
          return fetch(window.Shopify.routes.root + 'cart.js')
            .then(function (response) { return response.json(); })
            .then(function (cart) {
              cart.sections = responseJson.sections || {};
              addButton.dispatchEvent(
                new CustomEvent('variant:add', {
                  bubbles: true,
                  detail: {
                    items: responseJson.items || [responseJson],
                    cart: cart
                  }
                })
              );
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:change', {
                  bubbles: true,
                  detail: {
                    baseEvent: 'variant:add',
                    cart: cart
                  }
                })
              );
              resetSelection();
            });
        })
        .catch(function (error) {
          console.error('[ikara-samples]', error);
        })
        .finally(function () {
          addButton.removeAttribute('aria-busy');
          addButton.disabled = selectedCount() === 0;
        });
    });

    updateTotalPrice();
    updateAddButtonState();
  }

  function initAll() {
    document.querySelectorAll('.section-samples').forEach(initSamplesSection);
  }

  if (document.readyState === 'complete') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('section-samples')) {
      initSamplesSection(event.target);
    }
  });
})();
